import React from "react";
import backgroundImage from "../../assets/img/fondoOcho.jpg";
import UCPlogo from "../../assets/img/logoUCP.svg";
import logoCIE from "../../assets/img/logoCIE.svg";
import { Link } from "react-router-dom";

const UsuarioDashboard = () => {
  return (
    <div
      className="min-h-[100svh] flex flex-col relative"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div
        className="h-[6vmin] sm:h-[5vmin] md:h-[4vmin]"
        aria-hidden="true"
      />

      {/* Cabecera */}
      <div className="flex flex-col sm:flex-row items-center justify-center text-center gap-[1.8vmin] mt-[2vmin] mb-[3vmin] max-w-[1200px] mx-auto px-[3vmin]">
        <img
          src={UCPlogo}
          alt="UCP Logo"
          className="h-[10.5vmin] max-h-32 w-auto"
        />
        <h1
          className="font-montserrat font-extrabold text-white
                     text-[clamp(32px,6vmin,52px)]"
        >
          Identidad Institucional
        </h1>
      </div>

      {/* Contenido */}
      <main
        className="mx-auto max-w-[1200px] px-[3vmin] text-white font-montserrat
                   leading-[1.6] text-[clamp(16px,2.3vmin,21px)] mt-[1.2vmin]"
      >
        <div
          className="text-center font-bold mx-[2vmin] mb-[2.6vmin]
                     text-[clamp(22px,3.8vmin,34px)]"
        >
          ¡Bienvenido al aplicativo de Identidad Institucional de la Universidad
          Católica de Pereira!
        </div>

        <div
          className="mx-[2vmin] mb-[2.6vmin]
                     text-[clamp(17px,2.6vmin,22px)]"
        >
          En esta trivia te enfrentarás a 4 ó 5 niveles, cada uno con un
          material diferente (presentación, video o documento) que te ayudará a
          responder preguntas de selección múltiple con única respuesta o
          verdadero/falso.
          <ul className="list-none mt-[1.2vmin]">
            <li className="py-[0.9vmin]">
              El juego funciona por niveles: en cada uno encontrarás un recurso
              que deberás revisar antes de enfrentarte a preguntas de selección
              múltiple o verdadero/falso. Si aciertas, ganas tiempo extra; si te
              equivocas, perderás segundos y tendrás que volver a intentarlo. A
              medida que avances, desbloquearás nuevos niveles hasta llegar al
              desafío final. Tu progreso se verá reflejado en un tablero
              general, y al completar todo el recorrido recibirás tu constancia
              de participación. A lo largo de la trivia aprenderás sobre nuestra
              misión y visión, valores, símbolos institucionales, fundamentos
              filosóficos y pedagógicos y nuestra propuesta de formación
              humanista.
            </li>
          </ul>
        </div>

        <div
          className="mx-[2vmin] text-center
                     text-[clamp(16px,2.4vmin,20px)]"
        >
          <strong>
            ¡Atrévete a jugar, aprende y conviértete en un experto en nuestra
            identidad institucional!
          </strong>
        </div>
      </main>

      {/* Botón principal */}
      <div className="mt-auto mb-[2.8vmin]">
        <Link to="/niveles">
          <div className="flex justify-center">
            <button
              className="bg-white text-black font-bold rounded
                         py-[1.4vmin] px-[3.6vmin]
                         text-[clamp(16px,2.4vmin,20px)]
                         transform hover:scale-110 transition duration-150 ease-in-out
                         hover:shadow-[0_9px_20px_rgba(0,0,0,0.8)]"
            >
              Empezar
            </button>
          </div>
        </Link>
      </div>

      {/* Logo esquina */}
      <div className="absolute bottom-[1.4vmin] right-[1.2vmin] z-10">
        <img
          src={logoCIE}
          alt="Logo CIE"
          className="h-[5.6vmin] max-h-12 w-auto"
        />
      </div>
    </div>
  );
};

export default UsuarioDashboard;
